/**
 * All supported icon sizes.
 */
export const ICON_SIZES = ["xsmall", "small", "regular", "large"] as const;

/**
 * The icon size.
 */
export type IconSize = (typeof ICON_SIZES)[number];
